import React from 'react';

const UserContactCard = ({user}) => {
  return (
    <div className="p-0 text-left">
      {/* <div className="jr-card-header card-img-top mb-0 p-4 bg-grey lighten-4">
        <h3 className="card-heading">Our Office</h3>
        <p className="sub-heading">
          Fusce eget dolor id justo luctus commodo
          vel pharetra nisi. Donec velit libero
        </p>
      </div> */}

        <ul className="contact-list list-unstyled">
          <li className="media">
            <i className="zmdi zmdi-phone zmdi-hc-fw zmdi-hc-lg text-primary align-self-left"/>
            <span className="media-body">
                           {user.tel}
                        </span>
          </li>
          <li className="media">
            <i className="zmdi zmdi-email zmdi-hc-fw zmdi-hc-lg text-primary align-self-left"/>
            <span className="media-body">
                           {user.email}
                        </span>
          </li>
          <li className="media">
            <i className="zmdi zmdi-key zmdi-hc-fw zmdi-hc-lg text-primary align-self-left"/>
            <span className="media-body">
            {user.identityNo[0]+"********"+user.identityNo[user.identityNo.length-2]+user.identityNo[user.identityNo.length-1]}
                        </span>
          </li>
          {user.orcId !== null ? <li className="media">
            <i className="zmdi zmdi-google-earth zmdi-hc-fw zmdi-hc-lg text-primary align-self-left"/>
            <span className="media-body">
                          {user.orcId}
                        </span>
          </li> : null }
         
          <li className="media">
            <i className="zmdi zmdi-account zmdi-hc-fw zmdi-hc-lg text-primary align-self-left"/>
            <span className="media-body">
            {user.gender}
                        </span>
          </li>
         {user.address !== null ? <li className="media">
            <i className="zmdi zmdi-pin zmdi-hc-fw zmdi-hc-lg text-primary align-self-center"/>
            <span className="media-body">
            {user.address} <br />
            {user.city} {user.country}
                        </span>
          </li> : null}
        </ul>


    </div>
  );
};

export default UserContactCard;
